module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/paymentus/make-payment/receipt/payment-receipt/payment-receipt.component.css
// module id = ./src/app/payment/paymentus/make-payment/receipt/payment-receipt/payment-receipt.component.css
// module chunks = main